import { StoreState } from "./states";
import { ShaqFAQ } from '@/models/Objects';

export const getters = {
  getFAQ: (state: StoreState) => (): ShaqFAQ | undefined => {
    let min=0;
    let max=state.faqs.size;
    //let random =Math.floor(Math.random() * (+max - +min)) + +min;
    return state.faqs.get(1);
  },
};
